import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { publicApi } from '../utils/api';

/* ── Inline SVG icon components ─────────────────────────── */
const IconBroadcast = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6.34 6.34a8 8 0 1 0 11.32 0"/>
    <path d="M2.76 2.76a14 14 0 1 0 18.48 0"/>
    <circle cx="12" cy="12" r="2"/>
    <line x1="12" y1="14" x2="12" y2="22"/>
  </svg>
);

const IconUsers = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconTrophy = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="8 17 12 21 16 17"/>
    <line x1="12" y1="12" x2="12" y2="21"/>
    <path d="M7 4H4a2 2 0 0 0-2 2v1c0 3.31 2.69 6 6 6h8c3.31 0 6-2.69 6-6V6a2 2 0 0 0-2-2h-3"/>
    <rect x="7" y="2" width="10" height="4" rx="1"/>
  </svg>
);

const IconSmartphone = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
    <line x1="12" y1="18" x2="12.01" y2="18"/>
  </svg>
);

const IconBarChart = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
    <line x1="2" y1="20" x2="22" y2="20"/>
  </svg>
);

const IconMap = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
    <line x1="9" y1="3" x2="9" y2="18"/>
    <line x1="15" y1="6" x2="15" y2="21"/>
  </svg>
);

const IconCalendar = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const IconClipboard = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
    <line x1="9" y1="12" x2="15" y2="12"/>
    <line x1="9" y1="16" x2="13" y2="16"/>
  </svg>
);

const IconActivity = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </svg>
);

const IconFish = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-0.94 3.46-3.44 6-7 6s-7.56-2.54-8.5-6z"/>
    <path d="M18 12v0"/>
    <path d="M6.5 12 2 9v6l4.5-3z"/>
    <circle cx="14.5" cy="12" r="1" fill="currentColor"/>
  </svg>
);

export default function LandingPage() {
  const { siteName, logoUrl } = useTheme();
  const { isAuthenticated } = useAuth();
  const [tiers, setTiers] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    publicApi.getPricingTiers().then(res => {
      setTiers(res.data.data || []);
    }).catch(() => {});
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

      {/* ── Navbar ────────────────────────────────────────────── */}
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            {logoUrl ? (
              <img src={logoUrl} alt={siteName} style={{ height: '100%', width: 'auto', objectFit: 'contain' }} />
            ) : (
              <span style={{ color: 'var(--amber)', display: 'flex', alignItems: 'center' }}><IconFish /></span>
            )}
          </Link>

          <div className="navbar-links">
            <Link to="/public/events" className="navbar-link">Events</Link>
            {isAuthenticated ? (
              <Link to="/dashboard" className="btn btn-primary btn-sm">Dashboard</Link>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost btn-sm">Login</Link>
                <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
              </>
            )}
          </div>

          <button
            className="navbar-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`navbar-hamburger-icon${menuOpen ? ' open' : ''}`} />
          </button>

          <div className="navbar-mobile-auth" style={{ display: 'none' }}>
            {isAuthenticated ? (
              <Link to="/dashboard" className="btn btn-primary btn-sm">Dashboard</Link>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost btn-sm">Login</Link>
                <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
              </>
            )}
          </div>
        </div>
      </nav>

      <div className={`navbar-overlay${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(false)} />
      <div className={`navbar-drawer${menuOpen ? ' open' : ''}`}>
        <div className="navbar-drawer-links">
          <Link to="/public/events" className="navbar-drawer-link" onClick={() => setMenuOpen(false)}>Events</Link>
          {isAuthenticated ? (
            <Link to="/dashboard" className="navbar-drawer-link" onClick={() => setMenuOpen(false)}>Dashboard</Link>
          ) : (
            <>
              <Link to="/login" className="navbar-drawer-link" onClick={() => setMenuOpen(false)}>Login</Link>
              <Link to="/register" className="navbar-drawer-link" onClick={() => setMenuOpen(false)}>Get Started</Link>
            </>
          )}
        </div>
      </div>

      {/* ── Hero ──────────────────────────────────────────────── */}
      <section className="landing-hero">
        <div className="landing-hero-bg" aria-hidden="true" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
            <div className="landing-eyebrow">Built for Fishing Tournament Organizers</div>
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(2.2rem, 5.5vw, 3.6rem)',
              fontWeight: 700,
              lineHeight: 1.1,
              marginBottom: 20,
              overflow: 'hidden',
            }}>
              <span className="hero-line hero-line-left">Your Tournament.</span>
              <br />
              <span className="hero-line hero-line-right">Your Scoreboard.</span>
              <br />
              <span className="hero-line hero-line-zoom" style={{ color: 'var(--amber)' }}>Live.</span>
            </h1>
            <p style={{
              color: 'var(--text-secondary)',
              fontSize: 'clamp(1rem, 2.2vw, 1.15rem)',
              lineHeight: 1.7,
              marginBottom: 36,
              maxWidth: 520,
              margin: '0 auto 36px',
            }}>
              Real-time fishing tournament management. Create events, manage teams,
              log catches, and share live scoreboards with spectators on any screen.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/register" className="btn btn-primary landing-cta-btn">
                Start Your First Event
              </Link>
              <Link to="/public/events" className="btn btn-secondary landing-cta-btn">
                Browse Live Events
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Social Proof Strip ────────────────────────────────── */}
      <section className="landing-stats-strip">
        <div className="container">
          <div className="landing-stats-grid">
            {STATS.map(s => (
              <div key={s.label} className="landing-stat">
                <div className="landing-stat-value">{s.value}</div>
                <div className="landing-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How It Works ─────────────────────────────────────── */}
      <section className="landing-section">
        <div className="container">
          <div className="landing-section-header">
            <h2>Up and Running in Minutes</h2>
            <p>No spreadsheets, no manual tallying. Simple clean setup and a live scoreboard your anglers and sponsors will love.</p>
          </div>
          <div className="landing-steps">
            {HOW_IT_WORKS.map((step, i) => (
              <div key={step.title} className="landing-step">
                <div className="landing-step-icon" style={{ color: 'var(--amber)' }}>
                  {step.icon}
                </div>
                <div className="landing-step-num">{String(i + 1).padStart(2, '0')}</div>
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', marginBottom: 8 }}>
                  {step.title}
                </h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.88rem', lineHeight: 1.6 }}>
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Scoreboard Preview ───────────────────────────────── */}
      <section className="landing-section" style={{ background: 'var(--navy-light)', padding: '60px 20px' }}>
        <div className="container">
          <div className="landing-preview-wrap">
            <div className="landing-preview-text">
              <div className="landing-eyebrow" style={{ textAlign: 'left' }}>Live Scoreboard</div>
              <h2 style={{ textAlign: 'left', marginBottom: 16 }}>
                Real-Time Results, Zero Delay
              </h2>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: 24 }}>
                Every catch entered updates the leaderboard instantly across every device watching.
                Display it on the dock's big screen, your phone, or share a link — it just works.
              </p>
              <ul className="landing-check-list">
                <li>Instant socket-based updates — no refresh needed</li>
                <li>Supports multiple tournaments in one event</li>
                <li>Sort by weight, fish count, or custom scoring</li>
                <li>Shareable public URL for spectators</li>
              </ul>
            </div>
            <div className="landing-preview-card">
              <div className="landing-preview-header">
                <span style={{ fontFamily: 'var(--font-display)', fontSize: '0.95rem', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                  Salmon Classic - Live
                </span>
                <span className="badge badge-live" style={{ fontSize: '0.65rem' }}>Live</span>
              </div>
              {MOCK_SCOREBOARD.map((row, i) => (
                <div key={row.team} className="landing-preview-row" style={{
                  borderTop: i === 0 ? 'none' : '1px solid var(--border)',
                  background: i === 0 ? 'rgba(232,168,56,0.07)' : 'transparent',
                }}>
                  <span className="landing-preview-rank" style={{ color: i === 0 ? 'var(--amber)' : 'var(--text-muted)' }}>
                    #{i + 1}
                  </span>
                  <span style={{ flex: 1, fontWeight: i === 0 ? 600 : 400 }}>{row.team}</span>
                  <span style={{ color: 'var(--amber)', fontFamily: 'var(--font-display)', fontSize: '1rem' }}>
                    {row.weight}
                  </span>
                </div>
              ))}
              <div style={{ padding: '10px 16px', color: 'var(--text-muted)', fontSize: '0.72rem', borderTop: '1px solid var(--border)' }}>
                Updated just now · 14 teams competing
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Features ──────────────────────────────────────────── */}
      <section className="landing-section">
        <div className="container">
          <div className="landing-section-header">
            <h2>Everything You Need to Run a Derby</h2>
            <p>From the first sign-up to the final weigh-in — all in one platform.</p>
          </div>
          <div className="landing-features-grid">
            {FEATURES.map(f => (
              <div key={f.title} className="landing-feature-card card">
                <div className="landing-feature-icon" style={{ color: 'var(--amber)' }}>
                  {f.icon}
                </div>
                <h3 style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '1.05rem',
                  marginBottom: 8,
                }}>
                  {f.title}
                </h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.87rem', lineHeight: 1.6 }}>
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Pricing ───────────────────────────────────────────── */}
      <section className="landing-section" style={{ background: 'var(--navy-light)' }}>
        <div className="container">
          <div className="landing-section-header">
            <h2>Simple, Transparent Pricing</h2>
            <p>Pay per event. No subscriptions, no hidden fees. Every tier includes all features.</p>
          </div>

          {tiers.length === 0 ? (
            <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px 0' }}>
              Pricing information coming soon.
            </div>
          ) : (
            <div className="pricing-grid">
              {tiers.map((tier, i) => (
                <div key={tier.id} className="card" style={{
                  padding: '32px 24px',
                  textAlign: 'center',
                  border: i === 1 ? '2px solid var(--amber)' : '1px solid var(--border)',
                  position: 'relative',
                  overflow: 'hidden',
                }}>
                  {i === 1 && (
                    <div className="landing-pricing-popular">Most Popular</div>
                  )}
                  <h3 style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '1.2rem',
                    marginBottom: 12,
                  }}>
                    {tier.tier_name}
                  </h3>
                  <div style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '2.6rem',
                    fontWeight: 700,
                    color: 'var(--amber)',
                    lineHeight: 1,
                    marginBottom: 4,
                  }}>
                    ${parseFloat(tier.price_cad).toFixed(2)}
                  </div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.8rem', marginBottom: 20 }}>
                    CAD per event
                  </div>
                  <div style={{
                    color: 'var(--text-secondary)',
                    fontSize: '0.88rem',
                    padding: '14px 0',
                    borderTop: '1px solid var(--border)',
                    borderBottom: '1px solid var(--border)',
                    marginBottom: 20,
                  }}>
                    {tier.min_attendees}–{tier.max_attendees} expected attendees
                  </div>
                  <Link to="/register" className="btn btn-primary" style={{ width: '100%', display: 'block', textAlign: 'center' }}>
                    Get Started
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── Final CTA Banner ─────────────────────────────────── */}
      <section className="landing-cta-banner">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(1.6rem, 4vw, 2.4rem)',
            marginBottom: 12,
          }}>
            Ready to Run Your Next Derby?
          </h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 28, fontSize: '1rem', lineHeight: 1.7 }}>
            Join organizers across the world who trust DerbyScores to run their fishing tournaments.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-primary landing-cta-btn">
              Create Your Event
            </Link>
            <Link to="/public/events" className="btn btn-secondary landing-cta-btn">
              See Live Events
            </Link>
          </div>
        </div>
      </section>

      {/* ── Footer ────────────────────────────────────────────── */}
      <footer className="landing-footer">
        <div className="container">
          <div className="landing-footer-inner">
            <div className="landing-footer-brand">
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {logoUrl ? (
                  <img src={logoUrl} alt={siteName} style={{ height: 36, width: 'auto', objectFit: 'contain' }} />
                ) : (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--amber)' }}>
                    <IconFish />
                    <span style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                    }}>
                      {siteName}
                    </span>
                  </span>
                )}
              </span>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.82rem', marginTop: 8, lineHeight: 1.6 }}>
                Real-time tournament management<br />for fishing event organizers.
              </p>
            </div>
            <div className="landing-footer-links">
              <div className="landing-footer-col">
                <div className="landing-footer-col-title">Platform</div>
                <Link to="/public/events" className="landing-footer-link">Browse Events</Link>
                <Link to="/register" className="landing-footer-link">Get Started</Link>
                <Link to="/login" className="landing-footer-link">Sign In</Link>
              </div>
            </div>
          </div>
          <div className="landing-footer-bottom">
            {siteName} &copy; {new Date().getFullYear()} · Built for anglers, by anglers.
          </div>
        </div>
      </footer>
    </div>
  );
}

/* ── Data ───────────────────────────────────────────────── */

const STATS = [
  { value: 'TEAM & INDIVIDUAL', label: 'Derby Management' },
  { value: 'Multi-Tournament and Calcutta', label: 'Derby Features' },
  { value: 'Electronic Scoreboards', label: 'That Share Easily' },
];

const HOW_IT_WORKS = [
  {
    icon: <IconCalendar />,
    title: 'Create Your Event',
    description: 'Set up your tournament in minutes, define dates, species categories, registration limits and more.',
  },
  {
    icon: <IconClipboard />,
    title: 'Manage Teams & Entries',
    description: 'Teams register online or you can add them, view all events details and accept waivers. You approve rosters and track everything from your dashboard.',
  },
  {
    icon: <IconActivity />,
    title: 'Go Live & Score',
    description: 'Log catches as they happen. The leaderboard updates instantly for every spectator watching on any device.',
  },
];

const FEATURES = [
  {
    icon: <IconBroadcast />,
    title: 'Real-Time Scoreboards',
    description: 'Live leaderboards update instantly as catches are logged. Display on TVs, phones, or any browser.',
  },
  {
    icon: <IconUsers />,
    title: 'Team Management',
    description: 'Create teams, manage rosters, and handle join requests. Support for both team and individual formats.',
  },
  {
    icon: <IconTrophy />,
    title: 'Tournament Brackets',
    description: 'Run multiple tournaments within a single event. Track species, weights, and rankings simultaneously.',
  },
  {
    icon: <IconSmartphone />,
    title: 'Mobile Friendly',
    description: 'Fully responsive design works on any device. Log catches from the dock or the boat.',
  },
  {
    icon: <IconMap />,
    title: 'Circuit Standings',
    description: 'Track team performance across every tournament in your region with year-long circuit standings.',
  },
  {
    icon: <IconBarChart />,
    title: 'Event Analytics',
    description: 'Track registrations, catches, and participation with a complete audit log of all event activity.',
  },
];

const MOCK_SCOREBOARD = [
  { team: 'Deep Water Duo', weight: '18.4 lbs' },
  { team: 'Reel Legends', weight: '16.1 lbs' },
  { team: 'Hook & Sinker', weight: '15.7 lbs' },
  { team: 'Bass Hunters', weight: '14.2 lbs' },
  { team: 'Morning Rise', weight: '12.9 lbs' },
];
